// extracted by mini-css-extract-plugin
export default {"tabContainer":"styles_tabContainer__9MTo5","tab":"styles_tab__j4M5A"};